import { render } from "./AppIcon.vue?vue&type=template&id=0b644554&scoped=true"
import script from "./AppIcon.vue?vue&type=script&lang=ts"
export * from "./AppIcon.vue?vue&type=script&lang=ts"

import "./AppIcon.vue?vue&type=style&index=0&id=0b644554&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0b644554"

export default script